export default __webpack_public_path__ + "static/media/bg14.02b93d05.jpg";